import React from 'react'
import { AdjustAmount, Head } from '../../component'
import { TrackPageViewed } from '../../integrations/monitoring'
import { CheckoutPage } from '../../model'
import { useTranslation } from '../../utils/convergence'

export const AdjustAmountPage: CheckoutPage = () => {
  const { t } = useTranslation()
  const pageTitle = t('common:brandName')

  return (
    <>
      <Head title={pageTitle} />
      <AdjustAmount />
      <TrackPageViewed />
    </>
  )
}
